/**
 * The top-bar "?" (every skin, every module page): opens the Help Center
 * article for the page you are on, or the Help Center when the page has none.
 * The article lookup is a small id map; the corpus itself loads with /help.
 */
import { useNavigate } from '@tanstack/react-router';
import { CircleHelp } from 'lucide-react';
import { useActiveRoute } from '../../app/layout/activeRoute.js';
import { useOptionalSession } from '../../app/shell.js';
import { helpTargetFor } from './targets.js';
import './help-button.css';

export function HelpButton() {
  const session = useOptionalSession();
  const active = useActiveRoute();
  const navigate = useNavigate();
  if (session === null || session === undefined) return null;
  const target = helpTargetFor(active?.moduleId, active?.route.path);
  const label = target.title ? `Help: ${target.title}` : 'Help Center';
  return (
    <button
      type="button"
      className="shell-iconbtn hc-topbtn"
      aria-label={label}
      title={label}
      data-testid="help-button"
      onClick={() => void navigate({ to: target.href as never })}
    >
      <CircleHelp size={16} aria-hidden />
    </button>
  );
}
